<template>
    <div class="EnrollExistingSingleParticipantDiv">
        <div class="container-fluid">
            <div class="row vertical-align margin-top-1Point7Perc margin-bottom-2Perc">
                
                <div class="col-md-2 col-lg-2 width cursor-pointer img-align-middle" v-if="!comingFromUnEnrollment">
                  <a :href="downloadCSVUrl" class="text-decoration-none">
                    <img src= "../assets/images/download.svg" class="cursor-pointer img-responsive icon-width-height align-center" alt="download">
                  </a>
                </div>

                <div class="col-md-2 col-lg-2 width cursor-pointer img-align-middle" v-else>
                  <a class="text-decoration-none" @click="downloadUserUnenrollmentCSVTemplate">
                    <img src= "../assets/images/download.svg" class="cursor-pointer img-responsive icon-width-height align-center" alt="download">
                  </a>
                </div>  

                <div class="col-md-4 col-lg-4 text-align-left padding-left-2Point7Perc" v-if="!comingFromUnEnrollment">
                   <a :href="downloadCSVUrl" class="text-decoration-none">
                    Download CSV Template
                   </a>
                </div>

                <div class="col-md-4 col-lg-4 text-align-left padding-left-2Point7Perc" v-else>
                   <a class="text-decoration-none" @click="downloadUserUnenrollmentCSVTemplate">
                    Download CSV Template
                   </a>
                </div>

                <div class="col-md-2 col-lg-2 text-align-right">
                    Group Course(s)
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <select class="form-control" v-model="selectedGroupObj">
                              <option value=-1 disabled>Select</option>
                              <option v-for="groupCourseObj in getGroupCourseList" v-bind:key="groupCourseObj.GroupCourseMasterId" v-bind:value="groupCourseObj">{{ groupCourseObj.GroupName }} :: {{groupCourseObj.CourseTitle}} {{groupCourseObj.CourseSubTitle !== null && groupCourseObj.CourseSubTitle.trim().length !== 0 ? '[' + groupCourseObj.CourseSubTitle + ']': ''}}</option>
                            </select>
                        </div>
                    </div>
                </div><!-- end of cohort -->
            </div>
            <div class="row vertical-align margin-Top-2Perc margin-bottom-2Perc">
                <div class="col-md-2 col-lg-2 text-align-right">
                  Upload CSV
                </div>    
                <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                        <div class="col-sm-12">
                            <input type="file" id="uploadcsvfile" accept=".csv">
                        </div>
                    </div>
                </div>                
                <div class="col-md-2 col-lg-2 text-align-right">
                  Cohort(s)
                </div>    
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                            <div class="col-sm-12">
                              <select class="form-control" v-model="getSelectedCohortObjValue">
                                <option value='-1' disabled>Select</option>
                                <option v-for="cohortObj in getAssociatedCohorts" v-bind:key="cohortObj.CohortId" v-bind:value="cohortObj">{{ cohortObj.CohortName }}</option>
                              </select> 
                            </div>
                    </div>
                </div>
            </div>
            <div class="row vertical-align margin-top-3Perc margin-bottom-2Perc" v-if="!comingFromUnEnrollment">
                <div class="col-md-2 col-lg-2 text-align-right">
                </div>    
                <div class="col-md-4 col-lg-4 text-align-left">
                    <div class="form-group">
                        <div class="col-sm-12">
                          <input type="checkbox" v-model="overwriteUserGroupValue"> Overwrite User Group
                        </div>
                    </div>
                </div>                
                <div class="col-md-2 col-lg-2 text-align-right">
                </div>    
                <div class="col-md-4 col-lg-4">
                  <div class="form-group" v-if="showViewGoalAndActionOption">
                      <div class="col-sm-12">
                        <span class="text-color-blue cursor-pointer text-decoration-underline" @click="openViewGoalOverlay($event)">View Associated Goals & Actions</span>
                      </div>
                  </div>
                </div>
            </div>
            <div class="row margin-bottom-2Perc margin-Top-2Point5Perc">    
              <!-- ToDo: Track this -->
              <div class="center-align">
                <button class="btn btn-primary enroll-existing-button-BG black-font-color col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1" @click="validateBeforeUpload" :disabled="disableEnrollBtn">{{btnTextToShow}}</button>
              </div>
            </div>      
        </div>
        <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="performUserConfirmationAction"></confirmation-alert>
        <view-associated-leaps-challenges-for-cohort v-if="openViewGroupChallengeOverlay" :selectedCohortObj="selectedCohortObj" @updateValues="closeVisibleOverlay"></view-associated-leaps-challenges-for-cohort>
        <csv-upload-response-overlay v-if="showUploadCSVResponseOverlay" v-bind:selectedCohortObj="selectedCohortObj" v-bind:responseObj="getUploadCSVResponse" :comingFromUnEnrollment="comingFromUnEnrollment" @showCSVResponseOverlay="hideCSVResponseOverlay"></csv-upload-response-overlay>
        <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
        <!-- Show Spinner -->
        <div class="animationload" v-show="showSpinner">
          <div class="osahanloading"></div>
        </div> 
        <loader></loader>     
    </div>    
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import server from '@/utils/server'
import AlertBox from '@/components/AlertOverlay'
import CSVUploadResponseOverlay from '@/components/CSVUploadResponseOverlay'
import { cohortService } from '@/server-util/cohort-service'
import { groupCourseService } from '@/server-util/group-course-service'
import { participantService } from '@/server-util/participant-service'
import csvHelper from '@/utils/csv-helper'
import ViewAssociatedLeapsChallengesForCohort from './group/ViewAssociatedLeapsChallengesForCohort'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
export default {
  props: ['comingFromUnEnrollment'],
  created: function () {
    this.setDefaultValues()
    this.getAllGroupCourses()
  },
  data: function () {
    return {
      btnTextToShow: 'Enroll Participants',
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      selectedGroupObj: -1,
      selectedCohortObj: -1,
      associatedCohortList: [],
      showUploadCSVResponseOverlay: false,
      uploadCSVResponse: [],
      downloadCSVUrl: server.baseURL() + '/api/EnrollUser/DownloadUserCSVTemplate',
      overwriteUserGroup: false,
      showConfirmationBox: false,
      prefixString: '',
      postString: '',
      showViewGoalAndActionOption: false,
      availableLeapsChallengesForCurrentCohort: [],
      openViewGroupChallengeOverlay: false,
      disableEnrollBtn: false
    }
  },
  methods: {
    closeVisibleOverlay (value) {
      this.openViewGroupChallengeOverlay = false
      this.$store.state.isOverlayVisible = false
      this.fetchAssociatedGoalsAndActions()
    },
    openViewGoalOverlay: function (event) {
      this.openViewGroupChallengeOverlay = true
      this.$store.state.isOverlayVisible = true
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of confrimation overlay
      this.showConfirmationBox = value
    },
    performUserConfirmationAction: function (value) {
      if (value) {}
    },
    resetFields: function () {
      // AK: Reset all filters
      document.getElementById('uploadcsvfile').value = ''
      this.selectedGroupObj = -1
      this.selectedCohortObj = -1
      this.overwriteUserGroup = false
      this.showViewGoalAndActionOption = false
      this.disableEnrollBtn = false
    },
    setDefaultValues: function () {
      this.btnTextToShow = this.comingFromUnEnrollment ? 'Un-enroll Participants' : 'Enroll Participants'
      window.onfocus = () => {
        if (!this.openViewGroupChallengeOverlay && this.selectedGroupObj !== undefined && this.selectedGroupObj !== 'undefined' && this.selectedGroupObj !== null && this.selectedGroupObj !== 'null' && this.selectedGroupObj !== '' && this.selectedGroupObj !== -1 && this.selectedGroupObj.CourseMasterId === constants.Default_Meeting_Mentor_Course) {
          this.fetchAssociatedGoalsAndActions()
        }
      }
    },
    fetchAssociatedGoalsAndActions: function () {
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '' &&
        this.selectedCohortObj !== undefined && this.selectedCohortObj !== 'undefined' && this.selectedCohortObj !== null && this.selectedCohortObj !== 'null' && this.selectedCohortObj !== '' && this.selectedCohortObj !== -1 &&
        !this.openViewGroupChallengeOverlay
      ) {
        this.$store.state.isLoading = true
        cohortService
          .getAvailableChallengeForCohort(
            storeObj.state.access_token,
            this.selectedCohortObj.CohortId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.availableLeapsChallengesForCurrentCohort = responseObj.data.ChallengeActionsData
              if (this.availableLeapsChallengesForCurrentCohort.length === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No goals and actions are associated with this cohort. Please associate it!'
                this.disableEnrollBtn = true
              } else {
                this.disableEnrollBtn = false
                this.showAlertDialog = false
                this.errorMsg = ''
              }
              this.$store.state.isLoading = false
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            this.$store.state.isLoading = false
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING AVAILABLE CHALLENGE LIST'
        )
      }
    },
    downloadUserUnenrollmentCSVTemplate: function () {
      if (this.comingFromUnEnrollment) {
        var columnAlias = ['Email']
        var columnRespKey = ['']
        return csvHelper.export(null, columnRespKey, columnAlias, 'UserUnEnrollmentTemplate')
      }
    },
    hideCSVResponseOverlay (value) {
      // AK: its is used to hide the Response overlay
      this.showUploadCSVResponseOverlay = value
      // AK: enable background scrolling
      this.$store.state.isOverlayVisible = value
      this.resetFields()
    },
    getAllGroupCourses: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        // AK: If group courses are not available then only show spinner
        if (storeObj.state.groupCourseList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }
        groupCourseService
          .getGroupCourseList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupCourseList = responseObj.data
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            if (this.$store.state.isLoading === true) {
              // AK: Hide Spinner after recieving Group Course list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined GROUP COURSE LISTING OPERATION'
        )
      }
    },
    getAssociatedCohortList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedGroupObj !== -1
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        cohortService
          .getCohortListUsingGroupCourse(
            storeObj.state.access_token,
            this.selectedGroupObj.GroupCourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving Cohort list response
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.showAlertDialog = true
                var subTitleName = this.selectedGroupObj.CourseSubTitle === null ? '' : ' [' + this.selectedGroupObj.CourseSubTitle + ']'
                this.errorMsg = 'No cohort found in select \'' + this.selectedGroupObj.GroupName + ' :: ' + this.selectedGroupObj.CourseTitle + subTitleName + '\'.'
              }
              this.associatedCohortList = responseObj.data
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Selected Group ID is NULL hence declined LISTING Assciated Cohort(s) OPERATION'
        )
      }
    },
    validateBeforeUpload: function () {
      var fileUrl = document.getElementById('uploadcsvfile').files[0]
      if (this.selectedGroupObj !== -1) {
        if (this.selectedCohortObj !== -1) {
          if (fileUrl !== undefined) {
            if (!this.checkCSVFileExtesion(document.getElementById('uploadcsvfile').value)) {
              this.showAlertDialog = true
              this.errorMsg = 'Please select a valid file format.'
            } else {
              if (this.comingFromUnEnrollment) {
                this.uploadCSVTemplateForUnenrollment()
              } else {
                this.uploadCSVTemplateForEnrollment()
              }
            }
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Please select a .csv format.'
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg = 'Please select a cohort.'
        }
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a group course.'
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      if (this.errorMsg === 'No goals and actions are associated with this cohort. Please associate it!') {
        this.$store.state.hightLightOptionExplictly = false
        localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Users)
        localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.Cohorts)
        // this.$router.push('/cohorts?openAssGoalOverlay=true&cohortId=' + this.selectedCohortObj.CohortId + '&groupId=' + this.selectedGroupObj.GroupId)
        let routeData = this.$router.resolve({name: 'cohorts', query: {openAssGoalOverlay: 'true', cohortId: this.selectedCohortObj.CohortId, groupId: this.selectedGroupObj.GroupId}})
        window.open(routeData.href, '_blank')
      }
    },
    checkCSVFileExtesion: function (fileName) {
      var exts = ['.csv', '.CSV']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    uploadCSVTemplateForEnrollment: function () {
      var storeObj = this.$store
      var _this = this
      var fileUrl = document.getElementById('uploadcsvfile').files[0]
      const formData = new FormData()
      formData.append('CSVFile', fileUrl)
      formData.append('overwriteUserGroup', _this.overwriteUserGroupValue)

      // _this.showSpinner = true
      _this.$store.state.isLoading = true
      participantService
        .enrollMultipleParticipantUsingCSV(
          storeObj.state.access_token,
          _this.selectedCohortObj.CohortId,
          _this.selectedGroupObj.GroupId,
          formData
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            // AK: Hide Spinner after recieving success response
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            _this.uploadCSVResponse = responseObj.data
            // AK: Show server response to user in overlay
            _this.showUploadCSVResponseOverlay = true
            // AK: Disable background scrolling
            _this.$store.state.isOverlayVisible = true
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
          }
        }, errorObj => {
          // AK: Hide Spinner if error occured
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    },
    uploadCSVTemplateForUnenrollment: function () {
      var storeObj = this.$store
      var _this = this
      var fileUrl = document.getElementById('uploadcsvfile').files[0]
      const formData = new FormData()
      formData.append('UserCSV', fileUrl)

      // _this.showSpinner = true
      _this.$store.state.isLoading = true
      participantService
        .unEnrollMultipleParticipantUsingCSV(
          storeObj.state.access_token,
          _this.selectedCohortObj.CohortId,
          _this.selectedGroupObj.GroupId,
          formData
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            // AK: Hide Spinner after recieving success response
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            _this.uploadCSVResponse = responseObj.data
            // AK: Show server response to user in overlay
            _this.showUploadCSVResponseOverlay = true
            // AK: Disable background scrolling
            _this.$store.state.isOverlayVisible = true
            // AK: Check and show appropriate server response to user
            // _this.showServerResponseToUser(responseObj.data)
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
          }
        }, errorObj => {
          // AK: Hide Spinner if error occured
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    },
    showServerResponseToUser: function (serverResponseObj) {
      if (serverResponseObj.Error.trim() === 0) {
        // AK: Show server response to user in overlay
        this.showUploadCSVResponseOverlay = true
        // AK: Disable background scrolling
        this.$store.state.isOverlayVisible = true
      } else {
        // AK: Check Errors and show it to user
        switch (serverResponseObj.Error) {
          case '_SystemError_':
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            break
          case '_InvalidCSV_':
            this.showAlertDialog = true
            this.errorMsg = 'Invalid file format detected while processing your request.'
            break
        }
      }
    }
  },
  components: {
    'view-associated-leaps-challenges-for-cohort': ViewAssociatedLeapsChallengesForCohort,
    'alert-box': AlertBox,
    'csv-upload-response-overlay': CSVUploadResponseOverlay,
    'loader': Loader,
    'confirmation-alert': ConfirmationOverlay
  },
  computed: {
    getSelectedCohortObjValue: {
      get: function () {
        return this.selectedCohortObj
      },
      set: function (newValue) {
        this.selectedCohortObj = newValue
        if (this.selectedGroupObj.CourseMasterId === constants.Default_Meeting_Mentor_Course) {
          this.fetchAssociatedGoalsAndActions()
          this.showViewGoalAndActionOption = true
          this.disableEnrollBtn = true
        } else {
          this.showViewGoalAndActionOption = false
          this.disableEnrollBtn = false
        }
      }
    },
    overwriteUserGroupValue: {
      get: function () {
        return this.overwriteUserGroup
      },
      set: function (newValue) {
        this.overwriteUserGroup = newValue
      }
    },
    getGroupCourseList: {
      get: function () {
        return this.$store.state.groupCourseList
      }
    },
    getAssociatedCohorts: {
      get: function () {
        return this.associatedCohortList
      }
    },
    getUploadCSVResponse: {
      get: function () {
        return this.uploadCSVResponse
      }
    }
  },
  watch: {
    selectedGroupObj: function () {
      // AK: Reset flag to -1 as soon as user changes group course
      this.selectedCohortObj = -1
      this.getAssociatedCohortList()
    }
  },
  name: 'EnrollExistingSingleParticipantDiv'
}
</script>

<style scoped>
.text-decoration-underline {
  text-decoration: underline;
}
.text-color-blue {
  color: blue;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-2Point5Perc {
  margin-top: 2.5%;
}
.align-center {
  margin: 0 auto !important;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-align-left {
  text-align: left !important;
}
.font-size-20px {
  font-size: 20px;
}
.font-weight-bold {
  font-weight: bold;
}
.width {
  width: 5% !important;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.enroll-existing-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.width {
  width: 95%;
}
.cursor-pointer {
  cursor: pointer;
}
.icon-width-height {
  width: 40px;
  height: 40px;
}
.img-align-middle{
    margin-left: auto;
    margin-right: 0px;
}
.text-decoration-none {
  text-decoration: none !important;
}
.padding-left-2Point7Perc{
  padding-left:2.7%;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.text-align-right{
  text-align: right !important;
}
.border-red {
  border: 1px solid red;
}
.margin-top-1Point7Perc {
  margin-top: 1.7%
}
.center-align {
    margin: auto;
    width: 20%;
    /* border: 3px solid green; */
    /* padding: 10px; */
}
</style>


// WEBPACK FOOTER //
// src/components/EnrollMultipleParticipants.vue